import React from "react"
import { Flex } from "@chakra-ui/react"

export default function PackagePopular() {
  return (
    <Flex
      transform="rotate(45deg)"
      textTransform="uppercase"
      justifyContent="center"
      letterSpacing="wider"
      fontWeight="semibold"
      position="absolute"
      alignItems="center"
      color="gray.900"
      bg="primary.200"
      fontSize="sm"
      right={-54}
      w="200px"
      top={7}
      p={2}
    >
      Popular
    </Flex>
  )
}
